import Material from './Material';
import HotStamping from './HotStamping';
import Printing from './Printing';
import FlexoPrintingAndDieCutting from './FlexoPrintingAndDieCutting';
import GuillotineCutting from './GuillotineCutting';
import Cutting from './Cutting';
import Cellophane from './Cellophane';
import LacquerCoating from './LacquerCoating';
import Glueing from './Glueing';
import Lamination from './Lamination';
import Magnet from './Magnet';
import CoatingLabor from './CoatingLabor';
import Transport from './Transport';
import ProfitMargin from './ProfitMargin';
import VCutLabor from './VCutLabor';

export {
  Material,
  HotStamping,
  Cutting,
  GuillotineCutting,
  Printing,
  FlexoPrintingAndDieCutting,
  Cellophane,
  LacquerCoating,
  Glueing,
  Lamination,
  Magnet,
  CoatingLabor,
  Transport,
  ProfitMargin,
  VCutLabor,
};
